import React from 'react';
import { Button } from './ui/Button';
export function EstablishmentsSection() {
  return <section id="etablissements" className="bg-white py-[120px]" data-id="element-78">
      <div className="container mx-auto px-4 md:px-8 text-center" data-id="element-79">
        <div className="max-w-4xl mx-auto" data-id="element-80">
          <h2 className="text-[36px] md:text-[48px] font-bold text-arih-dark leading-tight mb-6" data-id="element-81">
            Etablissements membres de l'ARIH Agadir Souss Massa
          </h2>
          <p className="text-[18px] text-arih-gray leading-[28.8px] mb-10 max-w-3xl mx-auto" data-id="element-82">
            Un réseau d'hôtels et de structures d'hébergement engagés à offrir
            des expériences d'exception, reflétant l'hospitalité et l'excellence
            de notre région.
          </p>

          <a href="https://drive.google.com/file/d/1ioRzrd6QiBd9lpO7WHi5FrwFUeApChjX/view" target="_blank" rel="noopener noreferrer" data-id="element-83">
            <Button className="bg-arih-blue text-white rounded-full px-[53px] py-[9px] h-auto text-[16px] font-semibold hover:bg-blue-800 transition-colors shadow-none border-0" data-id="element-84">
              Découvrir les hôtels
            </Button>
          </a>
        </div>
      </div>
    </section>;
}